export default "__VITE_ASSET__335ee0e0__"